import { authenticateRequest } from '@api/authenticateRequest';

import type { operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type UpdateFamilyEventDetailsPath =
  operations['AdminEventController_getSendSmsResponse']['parameters']['path'];
type UpdateFamilyEventDetailsHeaders =
  operations['AdminEventController_getSendSmsResponse']['parameters']['header'];

interface UpdateFamilyEventDetailsProps {
  path: UpdateFamilyEventDetailsPath;
  headers?: OmitGroupIdInHeader<UpdateFamilyEventDetailsHeaders>;
}

type UpdateFamilyEventDetailsResponse = unknown;

export async function updateFamilyEventDetails({
  path,
  headers,
}: UpdateFamilyEventDetailsProps): Promise<UpdateFamilyEventDetailsResponse | false> {
  const response = await authenticateRequest<UpdateFamilyEventDetailsResponse>({
    method: 'post',
    url: `/api/v1/admin/events/${path.eventId}/response`,
    headers,
  });

  console.log('updateFamilyEventDetails', { response });
  return response;
}
